import React, { useRef, useState } from "react";
import styled, { ThemeProvider } from "styled-components";
import PropTypes from "prop-types";
import { useApolloClient } from "react-apollo";

import { Section, Container } from "rbx";

import ReactIdleTimer from "react-idle-timer";
import Footer from "./Footer";
import { theme } from "../styles/GlobalStyles";

// import Meta from "./Meta";

import { ModalProvider, ModalContext } from "./ModalProvider";

import Sidebar from "./Navigation/Sidebar";

import { logout } from "./Logout";

const StyledSection = styled(Section)`
  min-height: calc(100vh - 3.25rem);
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
`;
const MainContainer = styled.main`
  position: absolute;
  /* top: 3.25rem; */
  top: 0;
  left: 79px;
  right: 0;
`;

const Page = ({ children }) => {
  const client = useApolloClient();
  const idleTimer = useRef(null);
  const [state, setState] = useState({
    isModalOpen: false,
    modalContent: ""
  });

  const setModalOpen = (isModalOpen = true, modalContent = "") => {
    setState({ isModalOpen, modalContent });
  };

  const handleIdle = () => {
    logout(client);
  };

  // We remove this to prevent issues open modal changing the id in the url
  // const location = useLocation();
  // useEffect(() => {
  //   setModalOpen(false, "");
  // }, [location.key]);

  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <ModalContext.Provider
          value={{
            isModalOpen: state.isModalOpen,
            modalContent: state.modalContent,
            setModalOpen
          }}
        >
          <Sidebar />
          <MainContainer>
            <StyledSection>
              <Container fluid>{children}</Container>
            </StyledSection>
            <Footer />
          </MainContainer>
          <ReactIdleTimer
            debounce={5000}
            element={document}
            ref={idleTimer}
            timeout={1000 * 60 * 60}
            onIdle={handleIdle}
          />
          <ModalProvider />
        </ModalContext.Provider>
      </ThemeProvider>
    </React.Fragment>
  );
};

Page.propTypes = {
  children: PropTypes.node
};

export default Page;
